import React, { useEffect } from "react";
import styles from "../DevelopmentFinanceBlogs/DevelopmentFinanceBlogs.module.scss";
import Footer from "../../components/Footer";
import { useParams } from "react-router-dom";
import NewsContainer from "../../components/NewsContainer";
import CompareContainerC3 from "../../components/CompareContainer/CompareContainerC3";
import MatchingMortgagesC3 from "../../components/MatchingMortgages/MatchingMortgagesC3";
import LoanApplicationC3 from "../../components/LoanApplication/LoanApplicationC3";
import HeroSection from "../../components/HeroSection/HeroSection";
import TestimonialsContainer from "../../components/TestimonialsContainer";
// import TypeOfRequirements from "../../components/TypeOfRequirements";
import CallAdviser from "../../components/CallAdviser";

const CaseStudies3 = () => {
  const { blogId } = useParams();
  console.log(blogId);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.developmentFinanceBlogs}>
      <HeroSection title="Resources" />
      <CompareContainerC3 title="Resources" />
      {/* <TypeOfRequirements title="Resources" /> */}
      <CallAdviser title="Resources" />
      <MatchingMortgagesC3 title="Resources" />
      <NewsContainer title="Resources" />
      <LoanApplicationC3 title="Resources" />
      <TestimonialsContainer title="Resources" />
      <Footer title="Resources" />
    </div>
  );
};

export default CaseStudies3;
